import React from "react";
import {
  Modal,
  Button,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";

export interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
  disabled?: boolean;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message,
  confirmText = "Yes",
  cancelText = "No",
  isLoading = false,
  disabled = false,
}) => {
  return (
    <Modal
      className="modal confirmation_modal"
      open={open}
      onClose={isLoading ? undefined : onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          {/* Title */}
          <div
            className="modal_title"
            style={{ justifyContent: "center", marginBottom: "20px" }}
          >
            <Typography
              variant="h2"
              component="h2"
              sx={{ fontSize: "24px", fontWeight: 600 }}
            >
              {title}
            </Typography>
          </div>

          {/* Message Content */}
          <Box sx={{ textAlign: "center", marginBottom: "32px" }}>
            {typeof message === "string" ? (
              <Typography
                variant="body1"
                sx={{
                  fontSize: "16px",
                  lineHeight: 1.5,
                  color: "text.primary",
                }}
              >
                {message}
              </Typography>
            ) : (
              <Box sx={{ fontSize: "16px", lineHeight: 1.5 }}>{message}</Box>
            )}
          </Box>

          {/* Footer Buttons */}
          <div className="footer_btn_flex">
            <Button
              className="btn btn_grey"
              onClick={onClose}
              disabled={isLoading || disabled}
              sx={{ minWidth: "100px" }}
            >
              {cancelText}
            </Button>

            <Button
              className="btn btn_primary"
              onClick={onConfirm}
              disabled={isLoading || disabled}
              startIcon={
                isLoading ? (
                  <CircularProgress size={16} color="inherit" />
                ) : null
              }
              sx={{ minWidth: "100px" }}
            >
              {isLoading ? "Processing..." : confirmText}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationDialog;
